import React from 'react';

const ArrowRight = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.62069 1L18 10M18 10L9.62069 19M18 10L3.21853e-07 10" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export default ArrowRight;
